import { isBrowser } from 'src/utils/platform';
import { getDeviceType } from './deviceTypeUtils';
import useDimensions from './useDimensions';
export default function useDeviceType() {
    const [dimensions] = useDimensions();
    // Desktop browser: react to window width. WebView + native: smallest
    // dimension so landscape tablets stay tablet, not desktop.
    const referenceWidth = isBrowser
        ? dimensions.device.width
        : Math.min(dimensions.device.width, dimensions.device.height);
    return getDeviceType(referenceWidth);
}
